import { Epg } from 'common/constants/data-types';
import { calculateTimePercentages } from 'common/services/helpers';
import { isEmpty } from 'lodash';
import { calculateChannelProgress } from './helpers';
// @ts-ignore
import { arrayReduce } from 'fast-loops';

export const createContinueWatchingPropagator = (lastWatched: Epg[]) => {
  if (isEmpty(lastWatched)) return (epg: Epg) => epg;

  const lastWatchedEntries = arrayReduce(
    lastWatched,
    (acc: Record<string, Epg>, entry: Epg) => {
      acc[entry.eventid] = entry;
      return acc;
    },
    {}
  );
  // Keep the lookup local to this batch so new history data is always reflected.
  return (epg: Epg) => {
    const lastWatchedEntry = lastWatchedEntries[epg.eventid];
    if (lastWatchedEntry && lastWatchedEntry.skips?.continue) {
      const progress = calculateTimePercentages(
        epg.start,
        epg.stop,
        lastWatchedEntry.skips.continue.offset + epg.start
      );
      lastWatchedEntry.skips.continue.progress = lastWatchedEntry.now
        ? [progress, calculateChannelProgress(epg.start, epg.stop)]
        : progress;
      epg.skips = lastWatchedEntry.skips;
    }
    return epg;
  };
};
